<template>
	<span>
		<sf-data-table
			:pageUnit="groups.pageUnit"
			:totalSize="groups.totalSize"
			:currentPage="groups.currentPage"
			paging
			:columns="columns"
			:rows="this.resultList"
			:excel="isButton_(scrId, 'EX')"
			@changedPage="changedPage"
		/>
	</span>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/LoginHistory/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return { screen: {} };
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...serviceComputed,
		...rootComputed,
		columns() {
			return [
				{
					label: this.getMessage_('SWCC000216'),
					prop: 'loginDt',
					minWidth: '100px'
					//fixed: true
				},
				{
					label: this.getMessage_('SWCC000217'),
					prop: 'userId',
					minWidth: '100px'
					//fixed: true
				},
				{
					label: this.getMessage_('SWCC000218'),
					prop: 'userName',
					minWidth: '100px'
					//fixed: false
				},
				{
					label: this.getMessage_('SWCC000219'),
					prop: 'successYn',
					minWidth: '100px'
					//fixed: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.$emit('refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>
<style lang=""></style>
